// extracted by mini-css-extract-plugin
module.exports = {"menu":"index_menu__R1oOZ","barkly_container":"index_barkly_container__ery98"};